konnyScript(function($){
    
	//리뷰 헤택 내 슬라이드
    $('[id^=\'rvphoto_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#rvphoto_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#rvphoto_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#rvphoto_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#rvphoto_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#rvphoto_swiper_slide'+index+' .swiper-button-prev';
        var babySlide = new Swiper(this,{
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween : 10,
            centeredSlides: false,
            observer: true,
            observeParents: true,
            loop: true,
            speed:400,
            autoplay:{
                delay:800,
                disableOnInteraction:false,
            },
            pagination:true,
            pagination: {
                el: slidePage2,
                clickable: true,
            },
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
            breakpoints: {
                750: {
                    slidesPerView: 'auto', 
            		centeredSlides:true,
                },
            },
        });
    });
});